export default "__VITE_ASSET__CwHDCoza__"